import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";

import BaseModal from "@/components/BaseModal.vue";
import { PhWarningCircle } from "@phosphor-icons/vue";
import { useStore } from "@/store";

// ---- STATE ----


export default /*@__PURE__*/_defineComponent({
  __name: 'ParticipantIdModal',
  setup(__props) {

const participantId = ref("");
const store = useStore();
const isParticipantIdModalOpen = computed(
  () => store.state.isParticipantIdModalOpen,
);

// ---- CALLBACKS ----

const handleSubmitParticipantId = () => {
  if (participantId.value) {
    store.commit("setParticipantId", { participantId: participantId.value });
    store.commit("setParticipantIdModalClose");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_VRow = _resolveComponent("VRow")!
  const _component_VTextField = _resolveComponent("VTextField")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_VCol = _resolveComponent("VCol")!

  return (_openBlock(), _createBlock(BaseModal, {
    title: "Missing  Participant ID",
    persistent: "",
    titleStyle: { alignSelf: 'center' },
    model: isParticipantIdModalOpen.value
  }, {
    header: _withCtx(() => [
      _createVNode(_component_VRow, { style: {"justify-content":"center","align-items":"center","height":"80px"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(PhWarningCircle), {
            color: "red",
            size: "50px"
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_VCol, {
        class: "pa-0",
        style: {"display":"flex","flex-direction":"column","max-width":"400px","color":"#737373"}
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createTextVNode(" The participant ID could not be found in the URL. Please ask your supervisor for instructions. If you were given it verbally, please enter it manually. ")),
          _createVNode(_component_VTextField, {
            modelValue: participantId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((participantId).value = $event)),
            label: "Participant ID",
            dense: "",
            variant: "solo",
            rounded: "lg",
            style: {"margin-top":"16px"},
            "hide-details": "",
            density: "comfortable",
            flat: "",
            "bg-color": "#edf2fa"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_VBtn, {
            onClick: handleSubmitParticipantId,
            color: "red",
            style: {"align-self":"flex-end","margin-top":"16px"},
            disabled: !participantId.value
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Submit ")
            ])),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})